import React, { useEffect, useRef } from "react";

const ResetToDefaultPopover = ({ open, onClose, onConfirm, state = "idle" }) => {
  const popRef = useRef(null);

  const isResetting = state === "loading";
  const isDone = state === "done";
  const disableActions = isResetting || isDone;

  const confirmText = isResetting ? "Resetting" : isDone ? "Done" : "Yes, Reset";

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (disableActions) return;
      if (popRef.current && !popRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEsc = (e) => {
      if (disableActions) return;
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [open, onClose, disableActions]);

  if (!open) return null;

  return (
    <div
      ref={popRef}
      className="absolute z-50 top-[calc(100%+1px)] left-1/2 -translate-x-1/2"
    >
      {/* Arrow */}
      <div className="flex justify-center">
        <div className="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white drop-shadow-[0_-1px_0_rgba(228,228,231,1)]" />
      </div>

      {/* Card */}
      <div className="relative bg-white rounded-[12px] shadow-lg border border-[#E4E4E7]  max-w-[calc(100vw-240px)] px-6 py-5">
        <button
          onClick={() => {
            if (!disableActions) onClose();
          }}
          className="absolute right-4 top-4 text-[#71717A] hover:text-[#09090B] text-[18px] leading-none disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Close"
          disabled={disableActions}
        >
          ×
        </button>

        <h3 className="text-[18px] font-medium text-[#18181B] font-outfit text-center">
          Reset to Default?
        </h3>

        <div className="mt-3 text-center">
          <p className="text-[14px] text-[#71717A] font-outfit">
            This will remove all custom aspects
            <br />
            and reset all configuration values to
            <br />
            default settings.
          </p>
          <p className="text-[14px] text-[#71717A] font-outfit mt-3">
            This action cannot be undone.
          </p>
        </div>

        <div className="mt-6 flex items-center justify-center gap-4">
          <button
            onClick={() => {
              if (!disableActions) onClose();
            }}
            disabled={disableActions}
            className="px-6 py-2 rounded-[10px] border border-[#E4E4E7] text-[14px] font-medium text-[#09090B] font-outfit hover:bg-[#F4F4F5] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={disableActions}
            className="px-6 py-2 rounded-[10px] border border-[#E21919BF] text-[14px] font-medium text-[#E21919BF] font-outfit hover:bg-[#FEF2F2] disabled:opacity-50 disabled:cursor-not-allowed min-w-[120px]"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetToDefaultPopover;
